import { Component, createRef } from "react";
import { NSALayout, NSALayoutCustomProps } from "namirasoft-account-react";

export class SlackSenderLayout<RowType extends { id: string } = any, RowTypeInput = RowType> extends Component<NSALayoutCustomProps<RowType, RowTypeInput>>
{
	NSALayout_Ref = createRef<NSALayout<RowType, RowTypeInput>>();

	override render()
	{
		return (
			<NSALayout
				ref={this.NSALayout_Ref}
				{...this.props}
			>
				{this.props.children}
			</NSALayout>
		);
	}
}